import $ from "jquery";
// Ensure jQuery is truly global for plugins that check window.jQuery
window.jQuery = $
window.$ = $

// jquery-migrate patches deprecated jQuery APIs (must run after jQuery)
import "jquery-migrate";

// jquery-ui widgets
import "jquery-ui";

// Popper.js (Bootstrap 4 dependency - also configured in webpack ProvidePlugin)
import Popper from "popper.js";
window.Popper = Popper;

// Bootstrap 4 JS plugins
import "bootstrap4";
require("bootstrap-table");

// Flatpickr date picker and plugins
import flatpickr from "flatpickr";
import "flatpickr/dist/plugins/rangePlugin";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
window.flatpickr = flatpickr;
window.monthSelectPlugin = monthSelectPlugin;

// jQuery datetime picker
import "jquery-datetimepicker";

// Moment.js (exposed globally - used directly in view JS e.g. transactions.js)
import moment from "moment";
window.moment = moment;

// Cropper.js image cropper (exposed globally)
import Cropper from "cropperjs";
window.Cropper = Cropper;

// zxcvbn password strength estimator (exposed globally - used in password-indicator.js)
import zxcvbn from "zxcvbn";
window.zxcvbn = zxcvbn;

// Vendored libraries without npm equivalents
import Clipboard from "clipboard";
window.Clipboard = Clipboard;
// filterrific-jquery: copied from the filterrific gem into vendor/assets/javascripts
import "../../../vendor/assets/javascripts/filterrific/filterrific-jquery";
// jquery.readyselector: custom jQuery $.fn.ready selector plugin
import "../../../vendor/assets/javascripts/jquery.readyselector";
// notched-slider: custom slider component (UMD module)
import notchedSlider from "../../../vendor/assets/javascripts/notched-slider";
window.notchedSlider = notchedSlider;
